import { SOCIAL_PLATFORMS } from '~/constants';
import { formatAbbr } from '~/utils';

import { NOT_APPLICABLE } from '../SearchContentTable.constants';
import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { TextCell } from '../components/TextCell';

export const ColumnReach: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'reach',
    cell: ({ row }) => {
      if (row.original.platform === SOCIAL_PLATFORMS.instagram) {
        return (
          <TextCell>{formatAbbr(row.original.reach, NOT_APPLICABLE)}</TextCell>
        );
      }

      return <TextCell>{NOT_APPLICABLE}</TextCell>;
    },
  });
